export type ClinicalTrialAffiliatesType = {
  name: string;
  id: string;
  code: string;
};

export enum ClinicalTrialAffiliateNames {
  arthoshi = 'Arthrosi',
  jonson = 'Johnson & Johnson',
  bayer = 'Bayer Pharma',
  astra = 'AstraZeneca',
}
